var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#FFFFFF;}\n"),React.createElement("path",{"id":"Facebook","className":"st0","d":"M12.4,0L9.3,0C5.8,0,3.6,2.3,3.6,5.9v2.7H0.5C0.2,8.6,0,8.8,0,9v3.9c0,0.3,0.2,0.5,0.5,0.5h3.1\n\tv9.9c0,0.3,0.2,0.5,0.5,0.5h4c0.3,0,0.5-0.2,0.5-0.5v-9.9h3.6c0.3,0,0.5-0.2,0.5-0.5l0-3.9c0-0.1-0.1-0.3-0.1-0.3\n\tc-0.1-0.1-0.2-0.1-0.3-0.1H8.6V6.3c0-1.1,0.3-1.7,1.7-1.7l2.1,0c0.3,0,0.5-0.2,0.5-0.5V0.5C12.9,0.2,12.6,0,12.4,0z","key":1})]);
}

Facebook.defaultProps = {"version":"1.1","id":"Laag_1","x":"0px","y":"0px","viewBox":"0 0 12.9 23.8","style":{"enableBackground":"new 0 0 12.9 23.8"},"xmlSpace":"preserve"};

module.exports = Facebook;

Facebook.default = Facebook;
